export default __webpack_public_path__ + "static/media/cross.5822b540.svg";